export const defaultFdsFiltro = () => {
  return {
    nombre: '',
    fecha: '',
    version: '',
    page: 1,
    perPage: 10,
    sortBy: 'id',
    sort: 'DESC',
  };
};

// Identificación del producto
export const defaultSeccion1 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    tipo_documento: 'fds',
    nombre: '',
    sinonimos: '',
    usos_identificados: '',
    producto_externo: 0,
    id_fabricante: null,
    version: '0',
    activo: 1
  };
}

// Identificación de peligros
export const defaultSeccion2 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    categoriasfisicas: [],
    categoriassalud: [],
    categoriasambiental: [],
    categoriasNpeligrosas: [],
  };
}

// Información sobre componentes
export const defaultSeccion3 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    cas_no: '',
    tipo_producto: '',
    descripcion_compuesto: '',
  };
}

export const defaultSelectedComponente = () => {
  return {
    id: null,
    accion: 'crear',
    id_fds_producto: null,
    id_empresa: null,
    compuesto: '',
    cas: '',
    porcentaje: null,
  };
}

// Medidas de primeros auxilios
export const defaultSeccion4 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    instrucciones_generales: '',
    informacion_medico: '',
    contacto_piel: '',
    contacto_ojos: '',
    ingestion: '',
    inhalacion: '',
    sintomas: ''
  };
}

// Medidas de lucha contra incendio
export const defaultSeccion5 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    punto_inflamacion_rango: null,
    punto_inflamacion: null,
    punto_inflamacion_hasta: null,
    id_um_punto_inflamacion: null,
    limite_inf_sup_inflamabilidad: '',
    temperatura_ignicion_espontanea_rango: null,
    temperatura_ignicion_espontanea: null,
    temperatura_ignicion_espontanea_hasta: null,
    id_um_temperatura_ignicion_espontanea: null,
    medios_extincion: '',
    procedimiento: '',
    productos_combustion: '',
    medidas_especiales: ''
  };
}

// Medidas en caso de vertido accidental
export const defaultSeccion6 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    precauciones_personales: '',
    proteccion_personal: '',
    precaucion_medio_ambiente: '',
    limpieza_derrames_pequenos: '',
    limpieza_derrames_mayores: '',
  };
}

// Manejo y almacenamiento
export const defaultSeccion7 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    manejo: '',
    areas: '',
    almacenamiento: '',
    transferencia: '',
    recipientes: '',
    limpieza_depositos: '',
    precauciones_manipulacion: '',
  };
}

// Controles de exposición / protección personal
export const defaultSeccion8 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    controles_tecnicos: '',
    medidas_proteccion_individual: '',
    proteccion_respiratoria: '',
    proteccion_manos: '',
    proteccion_ojos: '',
    proteccion_caso_emergencia: '',
    consideraciones_higiene: '',
    proteccion_corporal: '',
  };
}

export const defaultSelectedValorExpo = () => {
  return {
    id: null,
    accion: 'crear',
    id_fds_producto: null,
    id_empresa: null,
    componente: '',
    twa_acgih: null,
    id_um_twa_acgih: null,
    twa_acgih_observacion: '',
    stel_acgih: null,
    id_um_stel_acgih: null,
    stel_acgih_observacion: '',
  }
}

export const defaultSelectedValorExpoOtros = () => {
  return {
    id: null,
    accion: 'crear',
    id_fds_producto: null,
    id_empresa: null,
    componentes: '',
    otros_tlv: '',
  }
}

export const defaultSelectedElementosProteccion = () => {
  return {
    accion: 'crear',
    id_fds_producto: null,
    id_empresa: null,
    elementos_proteccion: [],
  }
}

// Propiedades físicas y químicas
export const defaultSeccion9 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    estado: '',
    color: '',
    solubilidad: '',
    umbral_olor: '',
    presion_vapor_rango: null,
    presion_vapor: null,
    presion_vapor_hasta: null,
    id_um_presion_vapor: null,
    densidad_vapor_relativo_rango: null,
    densidad_vapor_relativo: null,
    densidad_vapor_relativo_hasta: null,
    id_um_densidad_vapor_relativo: null,
    punto_inflamacion_rango: null,
    punto_inflamacion: null,
    punto_inflamacion_hasta: null,
    id_um_punto_inflamacion: null,
    limite_inf_sup_inflamabilidad: '',
    temperatura_ignicion_espontanea_rango: null,
    temperatura_ignicion_espontanea: null,
    temperatura_ignicion_espontanea_hasta: null,
    id_um_temperatura_ignicion_espontanea: null,
    densidad_rango: null,
    densidad: null,
    densidad_hasta: null,
    id_um_densidad: null,
    temperatura_descomposicion_rango: null,
    temperatura_descomposicion: null,
    temperatura_descomposicion_hasta: null,
    id_um_temperatura_descomposicion: null,
    coeficiente_reparto: '',
    ph_rango: null,
    ph: null,
    ph_hasta: null,
    viscosidad_cinematica_rango: null,
    viscosidad_cinematica: null,
    viscosidad_cinematica_hasta: null,
    id_um_viscosidad_cinematica: null,
    punto_fusion_rango: null,
    punto_fusion: null,
    punto_fusion_hasta: null,
    id_um_punto_fusion: null,
    punto_congelacion_rango: null,
    punto_congelacion: null,
    punto_congelacion_hasta: null,
    id_um_punto_congelacion: null,
    punto_ebullicion_rango: null,
    punto_ebullicion: null,
    punto_ebullicion_hasta: null,
    id_um_punto_ebullicion: null,
    gravedad_especifica: '',
    punto_fluidez: '',
    inflamabilidad: '',
    otras_propiedades: '',
    contenido_compuestos_volatiles: '',
    porcentaje_volatilidad: '',
    concentracion_vapor_saturado: '',
    peso_molecular: '',
    carateristicas_particulas: '',
  };
}

// Reactividad y estabilidad
export const defaultSeccion10 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    reactividad: '',
    estabilidad: '',
    posibilidad_reacciones_peligrosas: '',
    condiciones_evitar: '',
    incompatibilidad: '',
    riesgos_polimerizacion: '',
    productos_descomposicion_peligrosos: '',
  };
}

// Seccion11
export const defaultSeccion11 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    pricipales_vias_exposicion: '',
    toxicidad_aguda_oral: '',
    toxicidad_aguda_dermica: '',
    toxicidad_aguda_inhalacion: '',
    corrosion_cutanea: '',
    lesiones_ocular_grave: '',
    sensib_respiratoria_cutanea: '',
    mutagen_cedulas_germinales: '',
    carcinogenicidad: '',
    toxicidad_reproduccion: '',
    toxicidad_organos_unica: '',
    toxicidad_organos_repetidas: '',
    peligro_aspiracion: '',
    informacion_adicional: '',
  };
}

// Carcinogenicidad
export const defaultSelectedCarcinogenicidad = () => {
  return {
    id: null,
    accion: 'crear',
    id_fds_producto: null,
    id_empresa: null,
    componente: '',
    id_grupo: null,
  }
}

export const defaultSelectedTransporte = () => {
  return {
    id: null,
    accion: 'crear',
    id_fds_producto: null,
    id_empresa: null,
    tipo_transporte: null,
    noun: '',
    riesgo_principal: '',
    riesgo_secundario: '',
    riesgo_secundario1: '',
    imagen_principal: null,
    imagen_secundario: null,
    imagen_secundario1: null,
  }
}

// Seccion12
export const defaultSeccion12 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    toxicidad: '',
    persistencia_degradabilidad: '',
    potencial_bioacumulacion: '',
    movilidad_suelo: '',
    resultados_valoracion: '',
    otros_efectos_adversos: '',
  };
}

export const defaultSelectedToxicidad = () => {
  return {
    id: null,
    accion: 'crear',
    id_fds_producto: null,
    id_empresa: null,
    id_via_ingreso: null,
    componente: '',
    id_animal: null,
    id_marcador: null,
    valor_rango: 0,
    id_simbolo: 1,
    valor: null,
    id_um_valor: null,
    id_simbolo_hasta: 1,
    valor_hasta: null
  };
}

// Información relativa a la eliminación de los productos
export const defaultSeccion13 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    metodo_desecho: '',
    eliminacion_embalaje: '',
  };
}

// Seccion14
export const defaultSeccion14 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
    nota: '',
  };
}

// Seccion15
export const defaultSeccion15 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
  };
}

// Seccion16
export const defaultSeccion16 = () => {
  return {
    id_fds_producto: null,
    id_empresa: null,
  };
}

export const defaults = () => {
  return [
    null,
    defaultSeccion1(),
    defaultSeccion2(),
    defaultSeccion3(),
    defaultSeccion4(),
    defaultSeccion5(),
    defaultSeccion6(),
    defaultSeccion7(),
    defaultSeccion8(),
    defaultSeccion9(),
    defaultSeccion10(),
    defaultSeccion11(),
    defaultSeccion12(),
    defaultSeccion13(),
    defaultSeccion14(),
    defaultSeccion15(),
    defaultSeccion16(),
  ];
}

export default {
  id_empresa: null,
  id_fds_producto: null,
  seccionActual: null,
  tipo_documento: 'fds',
  productos_fds: [],
  filtro_fds: defaultFdsFiltro(),
  tipo_peligro: '',
  tipo_toxicidad: '',
  accion: 'crear',
  error: [],
  versiones_producto_fds: [],
  componentes_detalle: [],
  valores_exposicion: [],
  carcinogenicidades: [],
  toxicidades: [],
  naciones_unidas: [],
  animales: [],

  selectedSeccion1: defaultSeccion1(),
  selectedSeccion2: defaultSeccion2(),
  selectedSeccion3: defaultSeccion3(),
  selectedSeccion4: defaultSeccion4(),
  selectedSeccion5: defaultSeccion5(),
  selectedSeccion6: defaultSeccion6(),
  selectedSeccion7: defaultSeccion7(),
  selectedSeccion8: defaultSeccion8(),
  selectedSeccion9: defaultSeccion9(),
  selectedSeccion10: defaultSeccion10(),
  selectedSeccion11: defaultSeccion11(),
  selectedSeccion12: defaultSeccion12(),
  selectedSeccion13: defaultSeccion13(),
  selectedSeccion14: defaultSeccion14(),
  selectedSeccion15: defaultSeccion15(),
  selectedSeccion16: defaultSeccion16(),

  selectedComponente: defaultSelectedComponente(),
  selectedValorExpo: defaultSelectedValorExpo(),
  selectedValorExpoOtros: defaultSelectedValorExpoOtros(),
  selectedElementosProteccion: defaultSelectedElementosProteccion(),
  selectedCarcinogenicidad: defaultSelectedCarcinogenicidad(),
  selectedToxicidad: defaultSelectedToxicidad(),
  selectedTransporte: defaultSelectedTransporte(),

  componentesFds: [],
  iarc_grupos: [],
  vias_ingreso: [],
  marcadores: [],
  items_sugerencias: [],
  tipos_transporte_list: [],
  elementos_proteccion: [],

  vista: null,
  getState: null
};
